import { render } from "./AutoVerificationServices.vue?vue&type=template&id=4004b6bd&scoped=true"
import script from "./AutoVerificationServices.vue?vue&type=script&lang=js"
export * from "./AutoVerificationServices.vue?vue&type=script&lang=js"

import "./AutoVerificationServices.vue?vue&type=style&index=0&id=4004b6bd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4004b6bd"]])

export default __exports__